module.exports = __webpack_public_path__ + "static/media/website-creator-bro-people.4c4c07ab.svg";